import { render, staticRenderFns } from "./TimeoffFooter.vue?vue&type=template&id=15417632&lang=html&"
import script from "./TimeoffFooter.vue?vue&type=script&lang=js&"
export * from "./TimeoffFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports